var $de5da9cdd5bee12a$exports = {};
$de5da9cdd5bee12a$exports = {
    "moreActions": `More actions`,
    "unavailable": `Unavailable, expand for details`,
    "backButton": (args)=>`Return to ${args.prevMenuButton}`
};


export {$de5da9cdd5bee12a$exports as default};
//# sourceMappingURL=en-US.module.js.map
